var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "container mt-5" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "text-center mt-3 code-promotion" }, [
        _c("div", { staticClass: "block-code" }, [
          _c(
            "p",
            {
              staticClass: "d-flex align-items-center",
              staticStyle: { "margin-bottom": "0px" }
            },
            [
              _c("strong", { ref: "textCode", staticClass: "text-code" }, [
                _vm._v("BNLINEMAN")
              ]),
              _vm._v(" \n                "),
              _vm.copied === false
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-copy",
                        on: {
                          click: function($event) {
                            return _vm.copy("BNLINEMAN")
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "filter",
                          attrs: {
                            src: "/static/img/copy-svgrepo-com.svg",
                            alt: "คัดลอก",
                            width: "30"
                          }
                        })
                      ]
                    )
                  ]
                : [_vm._m(1)]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm._m(2)
      ]),
      _vm._v(" "),
      _vm._m(3)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img-promotion" }, [
      _c("div", { staticClass: "content p-3" }, [
        _c("img", {
          staticClass: "responsive",
          attrs: {
            src:
              "https://beneat.s3.ap-southeast-1.amazonaws.com/promotions/lineman-promotion.png",
            alt: "lineman promotion"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn" }, [
      _c("img", {
        attrs: {
          src: "/static/img/check-circle-svgrepo-com-trans.svg",
          alt: "",
          width: "30"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mt-2" }, [
      _c("strong", [_vm._v("(จำกัด 1 User / 1 สิทธิ์)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mt-5 mb-4" }, [
      _c("p", [_vm._v("ดาวน์โหลดแอปได้ที่")]),
      _vm._v(" "),
      _c(
        "a",
        { attrs: { href: "https://apple.co/3LdSWNi", target: "_blank" } },
        [
          _c("img", {
            attrs: {
              height: "38",
              alt: "Line BeNeat",
              src: "/static/img/btn-app-store.svg"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("a", { attrs: { href: "https://bit.ly/3zAwDio", target: "_blank" } }, [
        _c("img", {
          attrs: {
            height: "38",
            alt: "Line BeNeat",
            src: "/static/img/btn-play-store.svg"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cdf2d94", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cdf2d94","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPage/LinemanPromotion.vue
// module id = 2480
// module chunks = 0